// PrivacyPage.jsx
import React from 'react';
import styled from 'styled-components';

const PrivacyContainer = styled.div`
  max-width: 64rem;
  margin: 0 auto;
  padding: 1.5rem;
  padding-bottom: 4rem;
  color: #f3f4f6;
`;

const PrivacyTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
`;

const PrivacySubtitle = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 1.5rem;
`;

const PrivacySection = styled.section`
  margin-bottom: 1rem;
`;

const PrivacyHeading2 = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #ffffff;
`;

const PrivacyList = styled.ul`
  list-style: disc;
  margin-left: 1.25rem;
  margin-bottom: 1rem;
`;

const PrivacyListItem = styled.li`
  line-height: 1.6;
`;

const PrivacyParagraph = styled.p`
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const Anchor = styled.a`
  color: #60a5fa;
  text-decoration: underline;
`;

export default function PrivacyPage() {
    return (
        <PrivacyContainer>
            <PrivacyTitle>Privacy Policy</PrivacyTitle>
            <PrivacySubtitle>Last Updated: July 1, 2025</PrivacySubtitle>

            <PrivacySection>
                <PrivacyHeading2>1. Information We Collect</PrivacyHeading2>
                <PrivacyList>
                    <PrivacyListItem><strong>Contact Details:</strong> Name, email, company role (via booking form).</PrivacyListItem>
                    <PrivacyListItem><strong>Usage Data:</strong> Appointment dates, session notes, feedback.</PrivacyListItem>
                </PrivacyList>
            </PrivacySection>

            <PrivacySection>
                <PrivacyHeading2>2. How We Use Your Data</PrivacyHeading2>
                <PrivacyList>
                    <PrivacyListItem>To schedule and conduct consultations.</PrivacyListItem>
                    <PrivacyListItem>To send you confirmations, reminders, and follow-up materials.</PrivacyListItem>
                    <PrivacyListItem>To improve our services (anonymized).</PrivacyListItem>
                </PrivacyList>
            </PrivacySection>

            <PrivacySection>
                <PrivacyHeading2>3. Sharing &amp; Disclosure</PrivacyHeading2>
                <PrivacyParagraph>
                    We do <strong>not</strong> sell or share your personal data with third parties except where required by law or to our service providers (e.g., Azure Communication Services for email).
                </PrivacyParagraph>
            </PrivacySection>

            <PrivacySection>
                <PrivacyHeading2>4. Data Retention</PrivacyHeading2>
                <PrivacyParagraph>
                    We retain your booking and consultation records for up to 3 years, unless you request earlier deletion.
                </PrivacyParagraph>
            </PrivacySection>

            <PrivacySection>
                <PrivacyHeading2>5. Your Rights</PrivacyHeading2>
                <PrivacyParagraph>
                    You may request access, correction, or deletion of your personal data at any time by <Anchor href="mailto:sanspaugh@zumosoft.com">emailing us</Anchor>.
                </PrivacyParagraph>
            </PrivacySection>

            <PrivacySection>
                <PrivacyHeading2>6. Security</PrivacyHeading2>
                <PrivacyParagraph>
                    We use industry-standard measures (encryption, secure servers) to protect your information.
                </PrivacyParagraph>
            </PrivacySection>

            <PrivacySection>
                <PrivacyHeading2>7. Contact Us</PrivacyHeading2>
                <PrivacyParagraph>
                    For any privacy concerns, please <Anchor href="mailto:sanspaugh@zumosoft.com">contact us</Anchor>.
                </PrivacyParagraph>
            </PrivacySection>
        </PrivacyContainer>
    );
}
